<!--
구매요청 물품가 과금 모달 (TASK-176 U6b-1 표시 · U6b-2 입력/제출)
------------------------------------
 - 페이지당 1 인스턴스 (구매요청 index.blade.php `ref="buyOrderChargeGoodsCost"`). 완료 카드 「물품가과금 (미과금 N)」 버튼이
     $refs.buyOrderChargeGoodsCost.open(bo_id) 로 연다 (bo_id = 구매정보 ID).
 - open(orderId) → GET /admin/buy-requests/orders/{id}/goods-cost (GoodsCostPreviewLogic) → 아래 data 에 주입 → 모달 표시. 실패 = 서버 메세지 alert (ajax 기본 처리) 후 모달 안 엶.
 - U6b-1 = 표시: 머리 (오더번호 · 결제액 · 구매수수료율 · 예치금 · 시스템 과금환율) · 소속 상품 표 (과금된 행 = 기록 현지금액 · 원화 순액 · 과금일 · 비용 링크) · 안내 · 경고.
 - U6b-2 = 입력 · 제출: 환율 (당일 localStorage 재사용) · 미과금 행 금액 입력 (0 = 과금 건너뜀) · 합계 비교 (정수 센트) · 차액 반영 · POST → 성공 알림 + refresh / 실패 = 모달 안 오류.
 - 복귀 결정 반영 (18b): 「이번 과금」 체크 폐지 (미과금 전부 대상) · 예치금 부족 = 안내만 · 환율 = 최근 사용 환율 참고 표시 +
     범위 밖이면 서버가 확인 요구 (Gonelo-Error-Code 176001 → 확인 창 → rate_confirmed 재제출) · charge_ids 미전송.
 - OPS-027 UI 수정 (2026-10-21 · 시안 안 1 「전표형」 채택): 머리 4칸 (오더번호+복사 · 실제결제금액 · 구매수수료율 · 미과금 N건) →
     율 미설정 경고 → 환율 줄 → 상품 표 → 하단 2열 (좌 과금비고 / 우 합계 박스 — 맨 아래 「이번 과금 원화」 강조) → 버튼 줄.
     예치금 · 시스템 과금환율 · 예치금 부족 안내 · 결제액 갱신 안내 · 평상시 최근 환율 안내 · 하단 사유 문구 제거 (A2·A3·A11·A13·A4)
     → 비활성 「과금완료」 라벨에 첫 막힌 사유 (A4) · 범위 밖 환율만 빨간 경고 (A13) · 결과 알림 = 서버 msg 그대로 (A7~A9 — 문구 생성 = 컨트롤러 1곳)
 - 글자 1rem 이상 · 표 행 배경색 변경 금지 (합계 박스 상태 줄·강조 줄만 배경)
-->
<template>
    <div ref="modal" uk-modal esc-close="false" bg-close="false" class="gc-modal">
        <div class="uk-modal-dialog uk-modal-body uk-text-left gc-dialog">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <h3 class="uk-modal-title gc-title">물품가 과금</h3>

            <div v-if="loading" class="gc-loading">불러오는 중...</div>

            <template v-if="!loading && order">
                <!-- 머리 4칸 : 해외오더번호 (복사) · 실제결제금액 · 구매수수료율 · 미과금 상품 -->
                <dl class="gc-facts gc-ctx">
                    <div class="gc-facts__cell">
                        <dt>해외오더번호</dt>
                        <dd class="gc-facts__codeline">
                            <span class="gc-ctx__code">{{ order.buy_order_code ? order.buy_order_code : '—' }}</span>
                            <copy v-if="order.buy_order_code" tooltip="오더번호 복사" :copy-text="order.buy_order_code"></copy>
                        </dd>
                    </div>
                    <div class="gc-facts__cell">
                        <dt>실제결제금액</dt>
                        <dd class="gc-facts__big gc-mono gc-ctx__pay">{{ paymentText }}</dd>
                    </div>
                    <div class="gc-facts__cell">
                        <dt>구매수수료율</dt>
                        <dd class="gc-facts__big gc-mono gc-ctx__fee":class="{'gc-red': feeRate === null}">{{ feeRate === null ? '미설정' : feeRatePct + '%' }}</dd>
                    </div>
                    <div class="gc-facts__cell">
                        <dt>미과금 상품</dt>
                        <dd class="gc-facts__big gc-mono gc-ctx__uncharged">{{ unchargedRows.length }}건</dd>
                    </div>
                </dl>

                <!-- 구매수수료율 미설정 (빨간 경고 + 회원 상세 링크) -->
                <div v-if="feeRate === null" class="gc-alert gc-alert--danger gc-no-fee-rate">
                    이 회원의 구매수수료율이 설정되지 않아 과금할 수 없습니다.
                    <a :href="memberUrl" target="_blank" rel="noopener" class="gc-alert__link">회원 상세 (회원사 센터비용 설정) 열기</a>
                </div>

                <!-- 서버 경고 (율 미설정은 위 전용 블록이 대신하므로 제외) -->
                <div v-for="w in otherWarnings" :key="w.code" class="gc-alert gc-alert--danger" :class="'gc-warn-' + w.code.toLowerCase().replace(/_/g, '-')">{{ w.msg }}</div>

                <div v-if="excludedCancelCount > 0" class="gc-alert gc-alert--info gc-excluded-cancel">
                    배송취소 {{ excludedCancelCount }}건 제외 — 결제액에 그 금액이 포함됐다면 일치하지 않을 수 있습니다.
                </div>

                <!-- 환율 줄 (미과금 상품이 있을 때만) — 평상시 안내 없음 · 범위 밖일 때만 아래 빨간 경고 1줄 -->
                <template v-if="unchargedRows.length > 0">
                    <div class="gc-rate">
                        <label class="gc-rate__label">환율 (1 {{ order.currency }} = ₩)</label>
                        <input type="text" inputmode="decimal" class="uk-input gc-rate__input" :class="{'gc-input--bad': rateTouched && (! rateValid || ! rateInRange)}" v-model="inputRate" :readonly="isKrw" :disabled="submitting" autocomplete="off" @input="rateTouched = true">
                        <span v-if="isKrw" class="gc-muted">원화 구매는 1 로 고정</span>
                    </div>
                    <div v-if="! isKrw && rateValid && ! rateInRange" class="gc-alert gc-alert--danger gc-rate-out">
                        최근 사용 환율 {{ recentRate }} ({{ recentRateDate }}) 대비 ±{{ Math.round(rateTolerance * 100) }}% 를 벗어났습니다 — 1단위 기준 환율인지 확인하세요. 진행하면 확인 창이 한 번 더 나옵니다.
                    </div>
                </template>

                <!-- 소속 상품 표 -->
                <div class="gc-table-wrap">
                    <table class="uk-table uk-table-middle gc-table">
                        <thead>
                            <tr>
                                <th>상품</th>
                                <th class="gc-num">구입단가 × 수량</th>
                                <th class="gc-center">상태</th>
                                <th class="gc-num">현지금액</th>
                                <th class="gc-num">원화 (수수료 포함)</th>
                                <th class="gc-center">과금일</th>
                                <th class="gc-center">비용</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="p in prods" :key="p.id" class="gc-row" :class="{'gc-row--charged': p.charged}" :data-prod-id="p.id">
                                <td class="gc-prod">
                                    <div class="gc-prod__wrap">
                                        <img v-if="p.img_url" :src="p.img_url" class="gc-prod__img" alt="">
                                        <div class="gc-prod__info">
                                            <div class="gc-prod__name">{{ p.name }}</div>
                                            <div class="gc-prod__sub">{{ prodSub(p) }}</div>
                                        </div>
                                    </div>
                                </td>
                                <td class="gc-num">{{ unitText(p) }}</td>
                                <td class="gc-center gc-nowrap">
                                    <span v-if="p.charged" class="gc-badge gc-badge--done">과금됨</span>
                                    <span v-else class="gc-badge gc-badge--un">미과금</span>
                                    <span v-if="p.has_failed" class="gc-badge gc-badge--failed">미결제</span>
                                </td>
                                <td class="gc-num">
                                    <template v-if="p.charged">
                                        <span v-if="p.calc" class="gc-calc">{{ moneyText(p.calc.local_amount, p.calc.currency) }}</span>
                                        <span v-else class="gc-unrecorded">기록 없음</span>
                                    </template>
                                    <template v-else>
                                        <input type="text" inputmode="decimal" class="uk-input uk-form-small gc-amount" :class="{'gc-input--bad': ! amountValid(amounts[p.id])}" v-model="amounts[p.id]" :disabled="submitting" autocomplete="off">
                                    </template>
                                </td>
                                <td class="gc-num">
                                    <span v-if="p.charged">₩{{ $formatNumber(p.net_krw, 0) }}</span>
                                    <span v-else-if="isZeroRow(p)" class="gc-skip">과금 건너뜀</span>
                                    <template v-else-if="rowCalc(p)">
                                        <span class="gc-krw">₩{{ $formatNumber(rowCalc(p).krw, 0) }}</span>
                                        <div class="gc-formula">{{ formulaText(rowCalc(p)) }}</div>
                                    </template>
                                    <span v-else class="gc-muted">-</span>
                                </td>
                                <td class="gc-center gc-nowrap gc-mono">{{ p.last_billing_at ? String(p.last_billing_at).substr(0, 10) : '—' }}</td>
                                <td class="gc-center">
                                    <a v-if="p.charged || (p.billing_ids && p.billing_ids.length)" :href="'/prods/' + p.id + '/cost-info'" target="_blank" rel="noopener" class="uk-link-reset"><span class="gc-badge gc-badge--un">비용</span></a>
                                    <span v-else class="gc-muted">—</span>
                                </td>
                            </tr>
                            <tr v-if="prods.length === 0">
                                <td colspan="7" class="gc-empty">소속 상품이 없습니다.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- 하단 2열 : 좌 = 과금비고 / 우 = 합계 박스 -->
                <div v-if="unchargedRows.length > 0" class="gc-form gc-bottom">
                    <div class="gc-memo">
                        <label class="gc-memo__label">과금비고(모든 상품의 과금에 동일한 비고작성)</label>
                        <input type="text" class="uk-input gc-memo__input" v-model="memo" maxlength="200" :disabled="submitting" autocomplete="off" placeholder="선택 입력 — 비용탭 비고 마지막 줄에 붙습니다">
                    </div>

                    <div class="gc-sum" :class="sumMatch ? 'gc-sum--ok' : 'gc-sum--bad'">
                        <div class="gc-sum__row">
                            <span>현지금액 합계</span>
                            <b class="gc-mono gc-sum__local">{{ moneyText(totalLocal, order.currency) }}</b>
                        </div>
                        <div class="gc-sum__row">
                            <span>실제결제금액</span>
                            <b class="gc-mono gc-sum__pay">{{ paymentCents === null ? '미입력' : moneyText(paymentCents / 100, order.currency) }}</b>
                        </div>
                        <div v-if="sumMatch" class="gc-sum__row gc-sum__state gc-sum__state--ok gc-sum__okmsg">
                            <span>✓ 합계가 결제금액과 일치합니다</span>
                            <span class="gc-mono">차액 0</span>
                        </div>
                        <div v-else-if="paymentCents !== null" class="gc-sum__row gc-sum__state gc-sum__state--bad gc-sum__diff">
                            <span class="gc-sum__diff-text">합계 불일치 · 차액 <span class="gc-mono">{{ moneyText(diffCents / 100, order.currency) }}</span></span>
                            <button type="button" class="uk-button uk-button-default uk-button-small gc-apply-diff" :disabled="submitting || ! diffApplicable" @click="applyDiff">차액을 첫 상품에 반영</button>
                        </div>
                        <div v-else class="gc-sum__row gc-sum__state gc-sum__state--bad">
                            <span>실제결제금액을 먼저 입력(갱신)하세요</span>
                        </div>
                        <div class="gc-sum__row gc-sum__total">
                            <span>이번 과금 원화</span>
                            <b class="gc-mono gc-sum__krw">{{ krwSumText }}</b>
                        </div>
                    </div>
                </div>

                <div v-if="errorMsg" class="gc-alert gc-alert--danger gc-error">{{ errorMsg }}</div>

                <div class="gc-foot">
                    <button class="uk-button uk-button-default uk-modal-close" type="button">닫기</button>
                    <button class="uk-button uk-button-primary gc-submit" type="button" :disabled="! canSubmit" @click="submit">{{ submitLabel }}</button>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            // csrf-token (U6b-2 제출용)
            csrfToken: String,
        },
        data: function () {
            return {
                // 불러오는 중
                loading: false,

                // 미리보기 응답 (GoodsCostPreviewLogic)
                order: null,           // {id, buy_order_code, payment_price, currency, user_id}
                feeRate: null,         // 비율 (0.03 = 3%) · null = 미설정
                feeRatePct: null,      // 표시용 % (3)
                // (예치금 · 예치금 부족 안내 · 시스템 과금환율 = 응답에 남아 있으나 표시 안 함 — OPS-027 UI 수정 A2·A3)
                recentRate: null,      // recent_exchange_rate (범위 검사 기준 · null = 검사 생략)
                recentRateDate: null,  // recent_exchange_rate_date (Y-m-d)
                rateTolerance: 0.3,
                excludedCancelCount: 0,
                prods: [],             // 소속 상품 전체 (과금됨 + 미과금)
                warnings: [],          // [{code, msg}]

                // 입력 상태 (apply 에서 초기화)
                inputRate: '',         // 환율 (문자열 입력)
                rateTouched: false,
                amounts: {},           // {prod_id: 물품가 과금액 (현지, 문자열)} — 모든 미과금 행 (0 = 건너뜀)
                memo: '',
                submitting: false,
                errorMsg: '',
            };
        },
        computed: {
            isKrw() {
                return !! this.order && this.order.currency === 'KRW';
            },

            // 환율 입력 유효 (양수, min 0.000001)
            rateValid() {
                return this.numericOk(this.inputRate) && parseFloat(this.inputRate) >= 0.000001;
            },

            // 최근 사용 환율 ±허용 범위 (경고 표시 전용 — 제출은 막지 않는다. 최근 환율 없음·KRW = 검사 생략)
            rateInRange() {
                if (this.isKrw || ! this.rateValid || this.recentRate === null || this.recentRate <= 0) {
                    return true;
                }
                return Math.abs(parseFloat(this.inputRate) / this.recentRate - 1) <= this.rateTolerance + 1e-9;
            },

            // 결제액 (정수 센트) · 없음/0 = null
            paymentCents() {
                if (! this.order) {
                    return null;
                }
                let v = this.order.payment_price;
                if (v === null || v === undefined || v === '' || isNaN(parseFloat(v)) || parseFloat(v) <= 0) {
                    return null;
                }
                return this.toCents(v);
            },

            // 현지 합 (정수 센트) = 과금된 행 기록 + 모든 미과금 행 입력 (체크 무관)
            totalCents() {
                let sum = 0;
                this.chargedRows.forEach((p) => {
                    if (p.calc) {
                        sum += this.toCents(p.calc.local_amount);
                    }
                });
                this.unchargedRows.forEach((p) => {
                    if (this.amountValid(this.amounts[p.id])) {
                        sum += this.toCents(this.amounts[p.id]);
                    }
                });
                return sum;
            },
            totalLocal() {
                return this.totalCents / 100;
            },
            diffCents() {
                return this.paymentCents === null ? 0 : this.paymentCents - this.totalCents;
            },
            sumMatch() {
                return this.paymentCents !== null && this.diffCents === 0;
            },

            // 차액 반영 가능 (첫 미과금 행 += 차액 이 0 이상)
            diffApplicable() {
                if (this.unchargedRows.length === 0 || this.diffCents === 0) {
                    return false;
                }
                let first = this.unchargedRows[0];
                let cur = this.amountValid(this.amounts[first.id]) ? this.toCents(this.amounts[first.id]) : 0;
                return cur + this.diffCents >= 0;
            },

            // 과금 대상 행 = 미과금 중 금액 > 0 (0 = 건너뜀)
            targetRows() {
                return this.unchargedRows.filter((p) => this.amountValid(this.amounts[p.id]) && parseFloat(this.amounts[p.id]) > 0);
            },

            // 이번 과금 원화 합 (과금 대상 행)
            krwSum() {
                let sum = 0;
                this.targetRows.forEach((p) => {
                    let c = this.rowCalc(p);
                    if (c) {
                        sum += c.krw;
                    }
                });
                return sum;
            },
            // 합계 박스 「이번 과금 원화」 — 율·환율이 없어 계산 불가면 「—」 (예치금 부족은 안내 안 함 — 부족분은 서버가 미결제(미수) 등록, A2)
            krwSumText() {
                if (this.feeRate === null || ! this.rateValid) {
                    return '—';
                }
                return '₩' + this.$formatNumber(this.krwSum, 0);
            },

            // 제출 불가 사유 (첫 번째 · 짧게 — 버튼 라벨 괄호에 표시, A4) — '' = 제출 가능
            blockReason() {
                if (this.submitting) {
                    return '처리 중';
                }
                if (! this.order || this.unchargedRows.length === 0) {
                    return '미과금 상품 없음';
                }
                if (this.feeRate === null) {
                    return '구매수수료율 미설정';
                }
                if (this.paymentCents === null) {
                    return '실제결제금액 미입력';
                }
                if (this.chargedRows.some((p) => ! p.calc)) {
                    // 비용탭에서 과금된 상품 = 현지금액 기록 없음 (표에 빨간 「기록 없음」)
                    return '합계 검증 불가';
                }
                if (! this.rateValid) {
                    return String(this.inputRate === null || this.inputRate === undefined ? '' : this.inputRate).trim() === '' ? '환율 미입력' : '환율 입력 오류';
                }
                if (this.unchargedRows.some((p) => ! this.amountValid(this.amounts[p.id]))) {
                    return '금액 입력 오류';
                }
                if (this.targetRows.length === 0) {
                    return '과금할 금액 없음';
                }
                if (this.targetRows.some((p) => this.rowCalc(p).krw < 1)) {
                    return '원화 1원 미만 상품';
                }
                if (! this.sumMatch) {
                    return '합계 불일치';
                }
                return '';
            },
            canSubmit() {
                return this.blockReason === '';
            },
            submitLabel() {
                return this.blockReason === '' ? '과금완료' : '과금완료 (' + this.blockReason + ')';
            },

            // 미과금 행 (U6b-2 입력 대상) · 과금된 행
            unchargedRows() {
                return this.prods.filter((p) => ! p.charged);
            },
            chargedRows() {
                return this.prods.filter((p) => p.charged);
            },

            otherWarnings() {
                return this.warnings.filter((w) => w.code !== 'NO_FEE_RATE');
            },

            memberUrl() {
                return this.order ? '/admin/users/' + this.order.user_id : '#';
            },

            // 머리 「실제결제금액」
            paymentText() {
                if (! this.order) {
                    return '';
                }
                let v = this.order.payment_price;
                return (v === null || v === undefined || v === '') ? '미입력' : this.moneyText(v, this.order.currency);
            },
        },
        methods: {
            /**
             * 모달 열기 (카드 「물품가과금」 버튼)
             * @param {Number} orderId 구매정보 ID
             */
            open(orderId) {
                if (this.loading) {
                    return;
                }
                this.loading = true;
                this.order = null;
                $.app.ajax.module.default({
                    type: 'get',
                    url: '/admin/buy-requests/orders/' + orderId + '/goods-cost',
                    dataType: 'json',
                    success: (r) => {
                        this.apply(r);
                        this.loading = false;
                        UIkit.modal(this.$refs.modal).show();
                    },
                    error: () => {
                        this.loading = false;
                    },
                });
            },

            // 응답 → data
            apply(r) {
                this.order = r.order;
                this.feeRate = (r.fee_rate === null || r.fee_rate === undefined) ? null : Number(r.fee_rate);
                this.feeRatePct = r.fee_rate_pct;
                this.recentRate = (r.recent_exchange_rate === null || r.recent_exchange_rate === undefined) ? null : Number(r.recent_exchange_rate);
                this.recentRateDate = r.recent_exchange_rate_date || null;
                this.rateTolerance = Number(r.rate_tolerance) || 0.3;
                this.excludedCancelCount = Number(r.excluded_cancel_count) || 0;
                this.prods = r.prods || [];
                this.warnings = r.warnings || [];

                // 입력 상태 초기화 — 미과금 행 전부 (금액 기본 = 단가×수량)
                let amounts = {};
                this.prods.forEach((p) => {
                    if (! p.charged) {
                        let d = parseFloat(p.default_local);
                        amounts[p.id] = isNaN(d) ? '0' : String(d);
                    }
                });
                this.amounts = amounts;
                this.memo = '';
                this.errorMsg = '';
                this.submitting = false;
                this.rateTouched = false;
                this.inputRate = this.order && this.order.currency === 'KRW' ? '1' : this.loadSavedRate(this.order ? this.order.currency : '');
            },

            // ---- 입력 보조 ----
            numericOk(v) {
                return /^\d+(\.\d+)?$/.test(String(v === null || v === undefined ? '' : v).trim());
            },
            // 금액 = 소수 2자리까지 (서버 round(L,2) 와 같은 값만 받는다 — 모달 「일치」 ↔ 서버 거부 · 표시 ≠ 과금 원화 차단)
            amountValid(v) {
                return /^\d+(\.\d{1,2})?$/.test(String(v === null || v === undefined ? '' : v).trim());
            },
            // 각 값 toFixed(2) → 정수 센트 (부동소수 합산 오차 방지)
            toCents(v) {
                return parseInt(parseFloat(v).toFixed(2).replace('.', ''), 10);
            },
            decimals() {
                return this.order && this.order.currency === 'JPY' ? 0 : 2;
            },

            // 행 계산 (입력 유효 + 율·환율 유효할 때만)
            rowCalc(p) {
                if (this.feeRate === null || ! this.rateValid || ! this.amountValid(this.amounts[p.id])) {
                    return null;
                }
                let L = parseFloat(this.amounts[p.id]);
                let rate = parseFloat(this.inputRate);
                return {
                    local: L,
                    fee: L * this.feeRate,
                    total: L * (1 + this.feeRate),
                    rate: rate,
                    krw: Math.round(Number((L * (1 + this.feeRate) * rate).toPrecision(15))),
                };
            },
            formulaText(c) {
                return this.$formatNumber(c.local, this.decimals()) + ' + ' + this.$formatNumber(c.fee, 2) + ' (' + this.feeRatePct + '%) = '
                    + this.$formatNumber(c.total, 2) + ' @ ' + c.rate;
            },

            // 미과금 행의 금액이 유효한 0 (과금 건너뜀)
            isZeroRow(p) {
                return this.amountValid(this.amounts[p.id]) && parseFloat(this.amounts[p.id]) <= 0;
            },

            // 차액을 첫 미과금 행에 반영
            applyDiff() {
                if (! this.diffApplicable) {
                    return;
                }
                let first = this.unchargedRows[0];
                let cur = this.amountValid(this.amounts[first.id]) ? this.toCents(this.amounts[first.id]) : 0;
                this.amounts[first.id] = ((cur + this.diffCents) / 100).toFixed(this.decimals());
            },

            // ---- 환율 당일 재사용 (localStorage — 실패해도 동작) ----
            rateStorageKey(currency) {
                return 'task176.goodsCostRate.' + currency;
            },
            todayText() {
                let d = new Date();
                let pad = (n) => (n < 10 ? '0' : '') + n;
                return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
            },
            loadSavedRate(currency) {
                try {
                    let raw = window.localStorage.getItem(this.rateStorageKey(currency));
                    if (! raw) {
                        return '';
                    }
                    let saved = JSON.parse(raw);
                    if (saved && saved.date === this.todayText() && this.numericOk(saved.rate)) {
                        return String(saved.rate);
                    }
                } catch (e) {
                    // 저장소 접근 불가 — 프리필 없음
                }
                return '';
            },
            saveRate(currency, rate) {
                try {
                    window.localStorage.setItem(this.rateStorageKey(currency), JSON.stringify({date: this.todayText(), rate: String(rate)}));
                } catch (e) {
                    // 저장소 접근 불가 — 무시
                }
            },

            // ---- 제출 ----
            submit(rateConfirmed) {
                if (! this.canSubmit) {
                    return;
                }
                this.errorMsg = '';
                this.submitting = true;

                // 미과금 전부 (0 = 서버가 건너뜀) — charge_ids 는 보내지 않는다
                let uncharged = {};
                this.unchargedRows.forEach((p) => {
                    uncharged[p.id] = String(this.amounts[p.id]).trim();
                });
                let currency = this.order.currency;
                let rate = this.inputRate;

                let data = {
                    '_token': this.csrfToken,
                    'exchange_rate': String(rate).trim(),
                    'fee_rate': String(this.feeRate),
                    'uncharged_amounts': uncharged,
                    'memo': this.memo,
                };
                if (rateConfirmed === true) {
                    data['rate_confirmed'] = 'yes';
                }

                $.app.ajax.module.default({
                    type: 'post',
                    url: '/admin/buy-requests/orders/' + this.order.id + '/goods-cost',
                    data: data,
                    success: (response) => {
                        if (! this.isKrw) {
                            this.saveRate(currency, String(rate).trim());
                        }
                        UIkit.modal(this.$refs.modal).hide();
                        UIkit.modal.alert(this.toHtml(this.resultText(response))).then(() => {
                            $.app.refresh();
                        });
                    },
                    // 기본 native alert 끔 — 오류는 모달 안 (.gc-error) 에만 표시
                    alert_error_msg: () => {},
                    error: (jqXHR) => {
                        this.submitting = false;
                        // 환율 확인 요구 (코드 176001) = 확인 창 → 「진행」 시 rate_confirmed 로 재제출 / 「취소」 시 모달 유지
                        if (jqXHR.status === 500 && jqXHR.getResponseHeader('Gonelo-Error-Code') === '176001') {
                            this.confirmRate(this.errorText(jqXHR));
                            return;
                        }
                        this.errorMsg = this.errorText(jqXHR);
                    },
                });
            },

            // 환율 확인 창 (서버 문구 그대로)
            confirmRate(message) {
                // stack: true = 과금 모달 위에 겹쳐 열기 (기본값은 먼저 열린 모달을 숨김) → 취소·재제출 결과가 과금 모달에 그대로 보임
                UIkit.modal.confirm(this.toHtml(message + '\n\n이 환율로 진행하시겠습니까?'), {stack: true}).then(() => {
                    this.submit(true);
                }, () => {
                    // 취소 — 과금 모달 유지
                });
            },

            // UIkit alert/confirm 은 문자열을 HTML 로 넣는다 → 이스케이프 후 줄바꿈만 <br> 로 변환 (서버 문구 XSS 방지)
            toHtml(text) {
                return String(text)
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;')
                    .replace(/'/g, '&#39;')
                    .replace(/\r?\n/g, '<br>');
            },

            // 성공 알림 문구 = 서버 msg 그대로 (2줄 「물품가 과금을 완료하였습니다.」 / 「처리완료 N건(미결제 M건) - 합계 ₩X」 —
            // 문구 생성 = 컨트롤러 ChargeGoodsCost::jsonResponse 1곳, OPS-027 UI 수정 A7~A9)
            resultText(r) {
                return r && r.msg ? r.msg : '물품가 과금을 완료하였습니다.';
            },

            errorText(jqXHR) {
                if (jqXHR.status === 422 && jqXHR.responseJSON) {
                    let errors = jqXHR.responseJSON.errors || jqXHR.responseJSON;
                    let msgs = [];
                    for (let field in errors) {
                        if (Array.isArray(errors[field])) {
                            msgs.push(errors[field][0]);
                        }
                    }
                    return msgs.join('\n') || '입력값을 확인하세요.';
                }
                if (jqXHR.responseJSON && jqXHR.responseJSON.msg) {
                    return jqXHR.responseJSON.msg;
                }
                // 서버 로직 거부 = HTTP 500 + 평문 메시지 (HTML 오류 페이지는 제외)
                if (jqXHR.status === 500 && jqXHR.responseText) {
                    let text = String(jqXHR.responseText).trim();
                    if (text !== '' && text.charAt(0) !== '<') {
                        return text;
                    }
                }
                if (jqXHR.status === 0) {
                    return '서버와 통신할 수 없습니다. 네트워크 연결, 브라우저 확장 프로그램(광고차단 등), 프록시 설정을 확인해 주세요.';
                }
                if (jqXHR.status === 419) {
                    return '세션이 만료되었습니다. 페이지를 새로고침(F5) 후 다시 시도해 주세요.';
                }
                return '요청 처리 중 오류가 발생했습니다. (HTTP ' + jqXHR.status + ')';
            },

            // 금액 표시 (JPY 소수점 없음)
            moneyText(val, currency) {
                let num = parseFloat(val);
                if (isNaN(num)) {
                    return '-';
                }
                return (currency ? currency + ' ' : '') + this.$formatNumber(num, currency === 'JPY' ? 0 : 2);
            },

            // 상품 보조줄 (브랜드 · 색상 · 사이즈 · 수량 · 단계)
            prodSub(p) {
                let parts = [p.brand, p.color, p.size].filter((v) => v !== null && v !== undefined && String(v) !== '');
                parts.push('수량 ' + p.amount);
                parts.push(p.state_text);
                return parts.join(' · ');
            },

            // 구입단가 × 수량 = 기본 현지금액
            unitText(p) {
                if (p.default_local === null || p.default_local === undefined) {
                    return '-';
                }
                return this.moneyText(p.default_local, p.currency);
            },
        },
    }
</script>

<style lang="scss" scoped>
    // OPS-027 UI 수정 A1 — 시안 안 1 「전표형」: 사무적 톤 · 굵은 구분선 · 숫자 등폭 우측 정렬 (사이트 기존 글꼴 — 웹폰트 추가 없음)
    // 글자 1rem 이상 · 표 행 배경색 변경 금지 (합계 박스 상태 줄·강조 줄만 배경) · scoped = 이 모달 한정
    $ink: #1d2228;
    $ink-2: #4a535d;
    $ink-3: #6b7280;
    $rule: #d9dde2;
    $rule-2: #eceff2;
    $field: #f7f8f9;
    $ok: #1f7a4d;
    $ok-bg: #e8f4ed;
    $ok-line: #9fcdb4;
    $bad: #b4232c;
    $bad-bg: #fbeced;
    $bad-line: #e7a9ad;
    $mono: "IBM Plex Mono", ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;

    .gc-dialog {
        width: 1100px;
        max-width: calc(100vw - 40px);
        color: $ink;
    }

    // 제목 아래 굵은 구분선
    .gc-title {
        margin: 0 0 18px;
        padding-bottom: 12px;
        border-bottom: 2px solid $ink;
        font-size: 1.3rem;
        font-weight: 600;
        color: $ink;
    }

    .gc-loading {
        padding: 24px 0;
        color: $ink-3;
    }

    .gc-mono {
        font-family: $mono;
        font-variant-numeric: tabular-nums;
    }

    .gc-red {
        color: $bad !important;
    }

    .gc-muted {
        color: #a3a9b3;
    }

    .gc-nowrap {
        white-space: nowrap;
    }

    // ---- 머리 4칸 ----
    .gc-facts {
        display: grid;
        grid-template-columns: 1.3fr 1fr 1fr 1fr;
        margin: 0 0 14px;
        border: 1px solid $rule;
    }

    .gc-facts__cell {
        min-width: 0;
        padding: 10px 14px;
        border-right: 1px solid $rule;

        &:last-child {
            border-right: 0;
        }

        dt {
            margin: 0 0 2px;
            color: $ink-3;
            font-size: 1rem;
            font-weight: 400;
        }

        dd {
            margin: 0;
            color: $ink;
            font-size: 1.1rem;
            font-weight: 600;
            word-break: break-all;
        }
    }

    .gc-facts__codeline {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 4px 8px;
    }

    .gc-facts__big {
        font-size: 1.3rem !important;
        white-space: nowrap;
        word-break: normal !important;
    }

    // ---- 알림 ----
    .gc-alert {
        margin: 0 0 12px;
        padding: 9px 12px;
        border: 1px solid;
        font-size: 1rem;

        &--danger {
            border-color: $bad-line;
            background: $bad-bg;
            color: $bad;
            font-weight: 500;
        }

        &--info {
            border-color: $rule;
            background: $field;
            color: $ink-2;
        }
    }

    .gc-alert__link {
        margin-left: 8px;
        color: inherit;
        text-decoration: underline;
    }

    // ---- 환율 줄 ----
    .gc-rate {
        display: flex;
        align-items: center;
        gap: 14px;
        margin: 0 0 14px;
        padding: 10px 14px;
        border: 1px solid $rule;
        background: $field;
    }

    .gc-rate-out {
        margin-top: -8px;
    }

    .gc-rate__label {
        min-width: 130px;
        font-size: 1rem;
        font-weight: 500;
        white-space: nowrap;
    }

    .gc-rate__input {
        width: 140px;
        height: 34px;
        border-color: #b9c0c7;
        background: #fff;
        font-family: $mono;
        font-size: 1rem;
        text-align: right;
    }

    // ---- 상품 표 ----
    .gc-table-wrap {
        overflow-x: auto;
        margin-bottom: 0;
    }

    .gc-table {
        margin: 0;
        font-size: 1rem;
        border-collapse: collapse;

        th {
            padding: 8px 10px;
            border-top: 1px solid $ink;
            border-bottom: 1px solid $ink;
            color: $ink-2;
            font-size: 1rem;
            font-weight: 500;
            text-transform: none;
            white-space: nowrap;
        }

        td {
            padding: 10px;
            border-bottom: 1px solid $rule-2;
            color: $ink;
        }
    }

    .gc-num {
        text-align: right !important;
        white-space: nowrap;
        font-family: $mono;
        font-variant-numeric: tabular-nums;
    }

    // 헤더 칸은 본문 글꼴 (숫자 칸 정렬만)
    .gc-table th.gc-num {
        font-family: inherit;
    }

    .gc-center {
        text-align: center !important;
    }

    // td 는 표 칸 그대로 (행 높이·구분선 정렬) — flex 는 안쪽 wrap 에만
    .gc-prod {
        min-width: 240px;
        vertical-align: middle;
    }

    .gc-prod__wrap {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .gc-prod__img {
        width: 40px;
        height: 40px;
        flex: none;
        object-fit: cover;
        border: 1px solid $rule;
    }

    .gc-prod__name {
        font-weight: 500;
    }

    .gc-prod__sub {
        color: $ink-3;
        font-size: 1rem;
    }

    .gc-badge {
        display: inline-block;
        margin: 1px 2px;
        padding: 0 7px;
        border: 1px solid #b9c0c7;
        background: #fff;
        color: $ink-2;
        font-size: 1rem;
        line-height: 1.5;
        white-space: nowrap;

        &--done {
            border-color: $ok-line;
            background: $ok-bg;
            color: $ok;
        }

        &--failed {
            border-color: $bad-line;
            background: $bad-bg;
            color: $bad;
        }
    }

    .gc-unrecorded {
        color: $bad;
        font-weight: 600;
    }

    .gc-empty {
        padding: 16px 0;
        text-align: center;
        color: $ink-3;
    }

    .gc-skip {
        color: $ink-3;
        font-family: inherit;
        font-weight: 500;
    }

    .gc-amount {
        width: 130px;
        height: 34px;
        border-color: #b9c0c7;
        background: #fff;
        font-family: $mono;
        font-size: 1rem;
        text-align: right;
    }

    .gc-input--bad {
        border-color: $bad !important;
        color: $bad;
    }

    .gc-krw {
        font-weight: 600;
    }

    .gc-formula {
        color: $ink-3;
        font-size: 1rem;
        white-space: nowrap;
    }

    // ---- 하단 2열 : 과금비고 / 합계 박스 ----
    .gc-bottom {
        display: grid;
        grid-template-columns: 1fr 400px;
        gap: 24px;
        align-items: start;
        margin: 16px 0 16px;
    }

    .gc-memo__label {
        display: block;
        margin-bottom: 6px;
        font-size: 1rem;
        font-weight: 500;
    }

    .gc-memo__input {
        width: 100%;
        height: 34px;
        border-color: #b9c0c7;
        background: #fff;
        font-size: 1rem;
    }

    .gc-sum {
        border: 1px solid $rule;
        font-size: 1rem;
    }

    .gc-sum__row {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        gap: 6px 12px;
        padding: 7px 14px;
        border-bottom: 1px solid $rule-2;

        &:last-child {
            border-bottom: 0;
        }

        b {
            font-weight: 600;
        }
    }

    .gc-sum--bad .gc-sum__local {
        color: $bad;
    }

    .gc-sum__state {
        font-weight: 500;

        &--ok {
            background: $ok-bg;
            color: $ok;
        }

        &--bad {
            background: $bad-bg;
            color: $bad;
        }
    }

    // 빨간 줄 위에서 대비되는 채움 버튼 (진한 빨강 바탕 · 흰 글자)
    .gc-sum .gc-apply-diff {
        border: 1px solid $bad;
        background: $bad;
        color: #fff;
        font-size: 1rem;
        font-weight: 600;
        text-transform: none;

        &:hover:not([disabled]) {
            background: darken($bad, 8%);
            color: #fff;
        }

        &[disabled] {
            opacity: .55;
            color: #fff;
        }
    }

    // 맨 아래 강조 줄 「이번 과금 원화」
    .gc-sum__total {
        background: $ink;
        color: #fff;
        font-size: 1.15rem;
        font-weight: 600;

        b {
            color: #fff;
        }
    }

    // ---- 버튼 줄 ----
    .gc-foot {
        display: flex;
        justify-content: flex-end;
        gap: 8px;
        padding-top: 14px;
        border-top: 1px solid $rule;
    }

    .gc-submit[disabled] {
        text-transform: none;
    }
</style>
